export const ROUTES = {
    root: '/',
    login: '/login',
    recuperar: '/recuperar-password',
    resetear: '/resetear-password',
    dashboard: '/dashboard',
    reservas: '/reservas',
    reservaNueva: '/reservas/nueva',
    reservaDetalle: (id = ':id') => `/reservas/${id}`,
    clases: '/clases',
    misClases: '/mis-clases',
    clientes: '/clientes',
    empleados: '/empleados',
    promotores: '/promotores',
    pagos: '/pagos',
    liquidaciones: '/liquidaciones',
    anticipos: '/liquidaciones/anticipos',
    gente: {
        disciplinasNiveles: '/gente/disciplinas-niveles',
    },
    catalogo: {
        tarifas: '/catalogo/tarifas',
        niveles: '/catalogo/niveles',
        valores: '/catalogo/valores',
        descuentos: '/catalogo/descuentos',
        metodosPago: '/catalogo/metodos-pago',
    },
    organizacion: {
        sucursales: '/organizacion/sucursales',
        pdv: '/organizacion/puntos-venta',
        puntosEncuentro: '/organizacion/puntos-encuentro',
    },
    admin: {
        usuarios: '/admin/usuarios',
        grupos: '/admin/grupos',
        parametros: '/admin/parametros',
    },
    forbidden: '/403',
    notFound: '/404',
};
